import { render, staticRenderFns } from "./LoyaltyOptInModal.vue?vue&type=template&id=72d3e842&scoped=true&"
import script from "./LoyaltyOptInModal.vue?vue&type=script&lang=js&"
export * from "./LoyaltyOptInModal.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyOptInModal.vue?vue&type=style&index=0&id=72d3e842&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d3e842",
  null
  
)

export default component.exports